import { AxiosResponse } from 'axios';
import { DEVICE_INFO_API_URL } from '../../../../config';
import deviceAxios from '../../../../utils/axios/device.axios';

const tryToUploadFiles = (data: FormData): Promise<AxiosResponse<any>> => {
    const url = `${DEVICE_INFO_API_URL}/hotel-world-user-invites/upload-chat-files`
    return deviceAxios.post(url, data);
};

const tryToUploadKnowledgeFilesAiService = (data: any): Promise<AxiosResponse<any>> => {
    const url = `${DEVICE_INFO_API_URL}/knowledge-base/upload-and-compare`
    return deviceAxios.post(url, data);
};

const tryToDeleteKnowledgeFileAiService = (id: string): Promise<AxiosResponse<any>> => {
    return deviceAxios.delete(`${DEVICE_INFO_API_URL}/knowledge-base/${id}`);
};

const tryToFetchKnowledgeFilesAiService = (): Promise<AxiosResponse<any>> => {
    return deviceAxios.get(`${DEVICE_INFO_API_URL}/knowledge-base/files`);
};

export const KnowledgeFilesService = {
	tryToUploadFiles,
    tryToUploadKnowledgeFilesAiService,
    tryToDeleteKnowledgeFileAiService,
    tryToFetchKnowledgeFilesAiService,
};